// extracted by mini-css-extract-plugin
module.exports = {"ctxMenu":"context-menu-element_ctxMenu__tW6B2","ctxMenu-btn":"context-menu-element_ctxMenu-btn__4RUo4","disabled":"context-menu-element_disabled__vrFqa"};